(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = Array.from(root.querySelectorAll('[data-banner-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-banner-dot]'));
    const pause = root.querySelector('[data-banner-pause]');
    if (!slides.length) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let paused = reducedMotion;
    let hovered = false;
    let focused = false;
    let current = 0;
    let timer;
    let touchStart;
    let suppressClick = false;
    const autoplay = root.dataset.autoplay === 'true' && slides.length > 1;
    const delay = Number(root.dataset.interval) || 8000;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      const nextImage = slides[(current + 1) % slides.length].querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
    };
    const schedule = () => {
      clearInterval(timer);
      if (autoplay && !paused && !hovered && !focused && !document.hidden) {
        timer = setInterval(() => show(current + 1), delay);
      }
    };
    const move = (index) => { show(index); schedule(); };
    dots.forEach((dot, index) => dot.addEventListener('click', () => move(index)));
    root.querySelector('[data-banner-prev]')?.addEventListener('click', () => move(current - 1));
    root.querySelector('[data-banner-next]')?.addEventListener('click', () => move(current + 1));
    const renderPause = () => {
      if (!pause) return;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Reanudar banners' : 'Pausar banners');
      pause.textContent = paused ? 'REANUDAR' : 'PAUSAR';
    };
    pause?.addEventListener('click', () => { paused = !paused; renderPause(); schedule(); });
    root.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) { focused = false; schedule(); }
    });
    root.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStart = { x: touch.clientX, y: touch.clientY };
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      if (!touchStart) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - touchStart.x;
      const dy = touch.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        suppressClick = true;
        move(current + (dx < 0 ? 1 : -1));
        setTimeout(() => { suppressClick = false; }, 400);
      }
    }, { passive: true });
    root.addEventListener('click', (event) => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    document.addEventListener('visibilitychange', schedule);
    root.addEventListener('ferreti:unload', () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', schedule);
    }, { once: true });
    show(0);
    renderPause();
    schedule();
  };
  document.querySelectorAll('[data-ferreti-banner-v4]').forEach(initialize);
  if (!window.ferretiBannerV4Events) {
    window.ferretiBannerV4Events = true;
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ferreti-banner-v4]').forEach(initialize);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-ferreti-banner-v4]').forEach(root => {
        root.dispatchEvent(new Event('ferreti:unload'));
      });
    });
  }
})();
